<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Campaign: {{ campaign.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <h6 class="text-uppercase" i18n>Campaign Details</h6>
    <hr />
    <dl class="row small">
      <dt class="col-3" i18n>Name</dt>
      <dd *ngIf="!campaignNameValidator" class="col-9">{{ campaign.name }}</dd>
      <dd *ngIf="campaignNameValidator" class="col-9 error" i18n>{{ campaign.name }} (invalid campaign name)</dd>
      <dt class="col-3" i18n>Created By</dt>
      <dd *ngIf="campaign.created_by !== null; else noUser" class="col-9">
        {{ campaign.created_by }}
      </dd>
      <dt class="col-3" i18n>Created On</dt>
      <dd class="col-9">{{ formattedCreatedTime }}</dd>
      <dt class="col-3" i18n>Last Updated By</dt>
      <dd *ngIf="campaign.last_updated_by !== null; else noUser" class="col-9">
        {{ campaign.last_updated_by }}
      </dd>
      <dt class="col-3" i18n>Last Updated On</dt>
      <dd class="col-9">{{ formattedUpdatedDate }}</dd>
      <ng-template #noUser>
        <dd class="col-9" i18n>Unknown</dd>
      </ng-template>
      <dt class="col-3" i18n>Description</dt>
      <dd class="col-9">{{ campaign.description }}</dd>
      <dt *ngIf="campaign.promoted" class="col-3" i18n>Promoted</dt>
      <dd *ngIf="campaign.promoted" class="col-9" i18n>True</dd>
      <dt *ngIf="showPromoterUsername" class="col-3" i18n>Promoted by</dt>
      <dd *ngIf="showPromoterUsername" class="col-9">{{ campaign.promoted_by }}</dd>
      <dt *ngIf="campaign?.status" class="col-3" i18n>Status</dt>
      <dd *ngIf="campaign?.status" class="col-9">{{ campaign.status | titlecase }}</dd>
      <dt
        class="col-3"
        nbTooltip="Real-time campaigns are triggered by events (e.g., MissionCancelationEvent,
            MissionEndEvent) and do not require an Insight."
        i18n-nbTooltip
        i18n
      >
        Real Time
      </dt>
      <dd class="col-9">
        <nb-checkbox status="info" [checked]="campaign.is_real_time" disabled></nb-checkbox>
      </dd>
      <dt class="col-3" i18n>Conditional Campaign</dt>
      <dd class="col-9">
        <nb-checkbox status="info" [checked]="show_condition" disabled></nb-checkbox>
      </dd>
      <div *ngIf="show_condition">
        <br />
        <h6 class="text-uppercase" i18n>Condition</h6>
        <hr />
      </div>
      <dt
        class="col-3"
        *ngIf="show_condition && condition_all.length > 0"
        nbTooltipPlacement="top"
        nbTooltip="Robot has received notifications from ALL of these campaigns"
        i18n-nbTooltip
        i18n
      >
        ALL
      </dt>
      <dd class="col-9" *ngIf="show_condition && condition_all.length > 0">
        <dl class="condition-list">
          <dd *ngFor="let condition of condition_all">
            <a [routerLink]="[]" (click)="viewCampaign(condition.campaign_id)">
              {{ condition.campaign_id }}
            </a>
          </dd>
        </dl>
      </dd>
      <dt
        class="col-3"
        *ngIf="show_condition && condition_any.length > 0"
        nbTooltipPlacement="top"
        nbTooltip="Robot has received notifications from ANY of these campaigns"
        i18n-nbTooltip
        i18n
      >
        ANY
      </dt>
      <dd class="col-9" *ngIf="show_condition && condition_any.length > 0">
        <dl class="condition-list">
          <dd *ngFor="let condition of condition_any">
            <a [routerLink]="[]" (click)="viewCampaign(condition.campaign_id)">
              {{ condition.campaign_id }}
            </a>
          </dd>
        </dl>
      </dd>
      <dt
        class="col-3"
        *ngIf="show_condition && condition_not_all.length > 0"
        nbTooltipPlacement="top"
        nbTooltip="Robot has NOT received notifications from ALL of these campaigns"
        i18n-nbTooltip
        i18n
      >
        NOT ALL
      </dt>
      <dd class="col-9" *ngIf="show_condition && condition_not_all.length > 0">
        <dl class="condition-list">
          <dd *ngFor="let condition of condition_not_all">
            <a [routerLink]="[]" (click)="viewCampaign(condition.campaign_id)">
              {{ condition.campaign_id }}
            </a>
          </dd>
        </dl>
      </dd>
      <dt
        class="col-3"
        *ngIf="show_condition && condition_not_any.length > 0"
        nbTooltipPlacement="top"
        nbTooltip="Robot has NOT received notifications from ANY of these campaigns"
        i18n-nbTooltip
        i18n
      >
        NOT ANY
      </dt>
      <dd class="col-9" *ngIf="show_condition && condition_not_any.length > 0">
        <dl class="condition-list">
          <dd *ngFor="let condition of condition_not_any">
            <a [routerLink]="[]" (click)="viewCampaign(condition.campaign_id)">
              {{ condition.campaign_id }}
            </a>
          </dd>
        </dl>
      </dd>
      <dt class="col-3" *ngIf="show_condition" i18n>Time Frame</dt>
      <dd class="col-9" *ngIf="show_condition" i18n>{{ time_frame }} days</dd>
    </dl>

    <ng-container *ngIf="!campaign.is_real_time">
      <h6 class="text-uppercase" i18n>Insight</h6>
      <hr />
      <dl class="row small">
        <dt class="col-3" i18n>Insight/Trigger ID</dt>
        <dd class="col-9">
          <a [routerLink]="[]" (click)="viewInsight(campaign.trigger_id)">{{ campaign.trigger_id }}</a>
        </dd>
      </dl>
    </ng-container>

    <h6 class="text-uppercase" i18n>Content</h6>
    <hr />
    <dl class="row small">
      <ng-container *ngIf="campaign.content_id !== null">
        <dt class="col-3" i18n>Content ID</dt>
        <dd class="col-9">
          <a [routerLink]="[]" (click)="viewContent(campaign.content_id)">{{ campaign.content_id }}</a>
        </dd>
      </ng-container>
    </dl>

    <h6 class="text-uppercase" i18n>Surveys</h6>
    <hr />
    <ng-container *ngFor="let survey of selectedSurveys">
      <dl class="row small">
        <dt class="col-2" i18n>Survey Name</dt>
        <dd class="col-4">
          <a [routerLink]="[]" (click)="viewSurvey(survey)"> {{ survey.name }}</a>
        </dd>
        <dt class="col-2" i18n>Survey ID</dt>
        <dd class="col-4">
          <a [routerLink]="[]" (click)="viewSurvey(survey)"> {{ survey.id }}</a>
        </dd>
      </dl>
    </ng-container>
    <ng-container *ngIf="selectedSurveys.length === 0">
      <dl class="row small">
        <dd class="col-9" i18n>There are no Surveys associated with this campaign</dd>
      </dl>
    </ng-container>

    <h6 class="text-uppercase" i18n>Action Details</h6>
    <hr />
    <dl class="row small">
      <dt class="col-3" i18n>Activated</dt>
      <dd class="col-9">
        <input type="checkbox" [ngModel]="campaign.enabled" disabled />
      </dd>
      <ng-container *ngIf="campaign.schedule_seconds !== null">
        <dt class="col-3" i18n>Schedule</dt>
        <dd class="col-9">{{ scheduleLabel }}</dd>
      </ng-container>
      <ng-container *ngIf="campaign.next_run_time !== null">
        <dt class="col-3" i18n>Next Run Time</dt>
        <dd class="col-9">{{ formattedNextRunTime }}</dd>
      </ng-container>
      <ng-container *ngIf="campaign.start_date !== null">
        <dt class="col-3" i18n>Start Time</dt>
        <dd class="col-9">{{ formattedStartTime }}</dd>
      </ng-container>
      <ng-container *ngIf="campaign.end_date !== null">
        <dt class="col-3" i18n>End Time</dt>
        <dd class="col-9">{{ formattedEndTime }}</dd>
      </ng-container>
      <ng-container *ngIf="campaign.frequency_days !== null">
        <dt class="col-3" i18n>Frequency</dt>
        <dd class="col-9" i18n>{{ campaign.frequency_days }} days</dd>
      </ng-container>
    </dl>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button
        *ngIf="displayPromotionButton"
        nbButton
        [disabled]="!disablePromotionButton"
        status="info"
        (click)="promoteCampaign()"
        i18n
      >
        Promote
      </button>
      <button *ngIf="displayManagementButtons" nbButton class="ml-3" status="success" (click)="activateCampaign()" i18n>
        Activate
      </button>
      <button
        *ngIf="displayManagementButtons"
        nbButton
        class="ml-3"
        status="danger"
        (click)="deactivateCampaign()"
        i18n
      >
        Deactivate
      </button>
      <button nbButton class="ml-3" status="info" (click)="close()" i18n>Close</button>
    </div>
  </nb-card-footer>
</nb-card>
